import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { Routes } from 'src/constants/index';
import { BenefitsEnum } from 'src/common-types/index';
import { IBenefitsState } from 'src/store/slices/index';
import { RootState } from 'src/store';
import { getBenefitInfo } from 'src/utils/index';
import { SkeletonGetawaysCondo } from '../skeleton-getaways-condo';
import './style.scss';

interface IMapStateToProps {
  benefitsStore: IBenefitsState;
}

interface IProps extends IMapStateToProps {}

const ZERO = 0;

export class GetawayCondoComponent extends React.Component<IProps, null> {
  render(): React.ReactNode {
    const { benefitsStore } = this.props;

    return (
      <div className="getaway__condo">
        <div className="getaway__container">
          <Link className="getaway__condo__back-link" to={`${Routes.Getaway}`}>
            <FormattedMessage id="getaways.back" />
          </Link>
          <h1 className="getaway__condo__title">
            <FormattedMessage id="getaways.condo.title" />
          </h1>
          <p className="getaway__condo__subtitle">
            <FormattedMessage id="getaways.condo.subtitle" />
          </p>
          {benefitsStore.benefits?.items ? (
            <div className="getaway__condo__wrapper">
              {getBenefitInfo(benefitsStore.benefits, BenefitsEnum.Getaways)[ZERO].childItems[
                ZERO
              ].childItems.map(({ imageUrl, title, description, url }, index) => (
                <Link key={`${index}-${title}`} to={url} className="getaway__condo__item">
                  <img className="getaway__condo__item_img" src={imageUrl} alt={title} />
                  <div className="getaway__condo__item_info">
                    <p className="getaway__condo__item_info_title">{title}</p>
                    <p className="getaway__condo__item_info_text">{description}</p>
                  </div>
                </Link>
              ))}
            </div>
          ) : (
            <SkeletonGetawaysCondo />
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state: RootState): IMapStateToProps => {
  return {
    benefitsStore: state.benefitsStore,
  };
};

export const GetawayCondo = connect(mapStateToProps, null)(GetawayCondoComponent);
